import React from "react";
import { mapperFormFields } from "../../../utils";
import {
  manageMapperFormNames,
  parameterTypes,
  fileNameTypes,
  passthroughParameterTypes,
} from "../../../utils/constants/mapper";
import { Tab, Tabs } from "react-bootstrap";
import TargetHeaderSection from "./TargetHeaderSection";
import TargetValueSection from "./TargetValueSection";
import TargetTypeSettings from "./TargetTypeSettings";
import PreviewSection from "./PreviewSection";
import { useDeepEffect } from "../../../abstracts";
import { isEmpty } from "lodash-es";
import { ConfigureTransformations } from "../MapAndTransform/ConfigureTransformations";

const TargetSection = ({
  isNewField,
  sections,
  setFieldValue,
  handleChange,
  isFixedWidth,
  values,
  keyValue,
  mappedData,
  setKey,
  errors,
  setClickToSelect,
  setFieldArrayName,
  disabledKeys,
  setDisabledKeys,
  index,
  hasHeader,
  fieldName,
  fieldIndex,
  showField = true,
  headerError,
  valueError,
  mapType,
}) => {
  const formName = manageMapperFormNames.MAP_AND_TRANSFORM_OUTPUT;
  const fields = mapperFormFields[formName];

  useDeepEffect(() => {
    if (!isEmpty(errors?.from) || !isEmpty(errors?.to)) {
      setKey("TypeSettings");
    } else if (!isEmpty(errors?.valueData?.value)) {
      setKey("Value");
    }
  }, [errors]);
  return (
    <div
      className="parentText"
      style={{
        marginLeft: showField ? "19.14rem" : "0rem",
        position: "absolute",
        top: "4.3rem",
      }}
    >
      <br />
      <Tabs
        activeKey={keyValue}
        onSelect={(k) => setKey(k)}
        className="borderin"
        mountOnEnter
        unmountOnExit
      >
        {!isFixedWidth ? (
          <Tab eventKey="Header" title="Header">
            <TargetHeaderSection
              fields={fields}
              hasHeader={hasHeader}
              setClickToSelect={setClickToSelect}
              setFieldArrayName={setFieldArrayName}
              headerError={headerError}
              valueError={valueError}
              mapType={mapType}
            />
          </Tab>
        ) : (
          <Tab eventKey="TypeSettings" title="Type Settings">
            <TargetTypeSettings
              fields={fields}
              values={values}
              setFieldValue={setFieldValue}
              setDisabledKeys={setDisabledKeys}
              index={index}
              handleChange={handleChange}
              disabledKeys={disabledKeys}
              mappedData={mappedData}
              fieldIndex={fieldIndex}
            />
          </Tab>
        )}
        <Tab eventKey="Value" title="Value">
          <TargetValueSection
            fields={fields}
            setKey={setKey}
            setClickToSelect={setClickToSelect}
            setFieldArrayName={setFieldArrayName}
            parameterTypes={
              mapType == 3
                ? passthroughParameterTypes
                : showField
                ? parameterTypes
                : fileNameTypes
            }
            headerError={headerError}
            valueError={valueError}
          />
        </Tab>
      </Tabs>

      <PreviewSection
        isNewField={isNewField}
        sections={sections}
        values={values}
        isFixedWidth={isFixedWidth}
        fields={fields}
        fieldName={fieldName}
        mapType={mapType}
      />
    </div>
  );
};

export default TargetSection;
